import React, { FC, memo } from 'react';
import { Box, Button, Grid, Paper } from '@material-ui/core';
import useCustomerPayment from 'src/hooks/customer-payment/use-customer-payment';
import { DatePickerRangeComponent } from 'src/components';
import { BranchListDropDown } from 'src/components/dropdown';
import useResolution from 'src/hooks/useResolution';
import { PaymentMode } from './PaymentMode';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { cleanUrlParams, dateToday, transformerDateField } from 'src/utils';
import { CommonCustomerPaymentPayload } from 'src/redux/slices/customer-payment';
import { PaymentTypeDropDown } from 'src/components/dropdown/PaymentTypeDropDown';
import { useNavigate } from 'react-router';

interface Props {}

const Component: FC<Props> = () => {
  const { xs, md } = useResolution();
  const navigate = useNavigate();
  const {
    customerPaymentParams,
    customerPaymentComputation,
    customerPaymentList,
    setParams,
    fetchComputation,
    fetchList
  } = useCustomerPayment();

  const onChangedDate = (
    date: MaterialUiPickersDate,
    field: 'from' | 'to',
    params: CommonCustomerPaymentPayload,
    dateKey: string
  ) => {
    const transformedDate = date ? transformerDateField(date) : undefined;

    if (field === 'to') {
      setParams({
        ...params,
        [dateKey]: transformedDate || ''
      });
    }
    if (field === 'from') {
      setParams({
        ...params,
        [dateKey]: transformedDate || ''
      });
    }
  };

  const onApplyFilter = (params: CommonCustomerPaymentPayload) => {
    const cleanParams = cleanUrlParams({ ...params, page: 1 });
    fetchComputation(params);
    setParams({ ...params, page: 1 });

    if (customerPaymentList?.list?.length > 0) {
      fetchList({ ...params, page: 1 });
    }

    navigate(`?${cleanParams.toString()}`);
  };

  return (
    <Paper>
      <div>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                p: xs || md ? 0 : 3
              }}
            >
              <div style={{ padding: '10px 0px' }}>
                <DatePickerRangeComponent
                  title="Date Sold to Customer"
                  fullwidth={true}
                  toDateMin={customerPaymentParams?.sold_date_from}
                  fromDateMax={dateToday()}
                  fromDateValue={customerPaymentParams?.sold_date_from || null}
                  toDateValue={customerPaymentParams?.sold_date_to || null}
                  dateToLabel="To"
                  dateFromLabel="From"
                  onChangeToDate={(date) =>
                    onChangedDate(
                      date,
                      'to',
                      customerPaymentParams,
                      'sold_date_to'
                    )
                  }
                  onChangeFromDate={(date) =>
                    onChangedDate(
                      date,
                      'from',
                      customerPaymentParams,
                      'sold_date_from'
                    )
                  }
                />
              </div>

              <div style={{ padding: '10px 0px' }}>
                <DatePickerRangeComponent
                  title="Payment Date"
                  fullwidth={true}
                  toDateMin={customerPaymentParams?.payment_date_from}
                  fromDateMax={dateToday()}
                  fromDateValue={
                    customerPaymentParams?.payment_date_from || null
                  }
                  toDateValue={customerPaymentParams?.payment_date_to || null}
                  dateToLabel="To"
                  dateFromLabel="From"
                  onChangeToDate={(date) =>
                    onChangedDate(
                      date,
                      'to',
                      customerPaymentParams,
                      'payment_date_to'
                    )
                  }
                  onChangeFromDate={(date) =>
                    onChangedDate(
                      date,
                      'to',
                      customerPaymentParams,
                      'payment_date_from'
                    )
                  }
                />
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                p: xs || md ? 0 : 3
              }}
            >
              <div style={{ padding: xs || md ? '10px 0px' : '38px 0px' }}>
                <BranchListDropDown
                  paperSpace={0}
                  allowNoSelectedBranch={false}
                  defaultValue={
                    customerPaymentParams?.branch_id
                      ? [Number(customerPaymentParams.branch_id)]
                      : []
                  }
                  isElevated={false}
                  onHandleBranchChange={(branchIds?: number[]) =>
                    setParams({
                      ...customerPaymentParams,
                      branch_id: branchIds ? branchIds[0] : undefined
                    })
                  }
                />
              </div>

              <div style={{ padding: '12px 0px' }}>
                <PaymentTypeDropDown
                  initialValue={
                    customerPaymentParams?.payment_types
                      ? customerPaymentParams?.payment_types
                      : undefined
                  }
                  onHandleChange={(payment: any) =>
                    setParams({
                      ...customerPaymentParams,
                      payment_types: payment ? payment : undefined
                    })
                  }
                />
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <PaymentMode />
            <Box
              sx={{
                width: '100%',
                marginTop: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Button
                variant="contained"
                size="large"
                color="primary"
                style={{ padding: '15px 70px', marginBottom: 20 }}
                onClick={() => onApplyFilter(customerPaymentParams)}
                disabled={customerPaymentComputation?.is_loading}
              >
                Apply Filter
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export const Toolbar = memo(Component);
